/* KIZA - Kazo-style layer: small behaviours only. */
(function () {
  var d = document;

  function fmt(cents) {
    var f = (window.KZO && window.KZO.moneyFormat) || 'Rs. {{amount}}';
    var a = cents / 100;
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k.indexOf('no_decimals') > -1) return Math.round(a).toLocaleString('en-IN');
      return a.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }

  // rotating announcement
  d.querySelectorAll('[data-kzo-ann]').forEach(function (el) {
    var s = el.querySelectorAll('span');
    if (s.length < 2) return;
    var i = 0;
    setInterval(function () {
      s[i].classList.remove('is-on');
      i = (i + 1) % s.length;
      s[i].classList.add('is-on');
    }, 4000);
  });

  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var o = t.closest('[data-kzo-open]');
    if (o) {
      var dr = d.getElementById(o.getAttribute('data-kzo-open'));
      if (dr) { dr.classList.add('is-open'); d.documentElement.style.overflow = 'hidden'; }
      return;
    }
    var c = t.closest('[data-kzo-close]');
    if (c) {
      var p = c.closest('.kzo-drawer');
      if (p) { p.classList.remove('is-open'); d.documentElement.style.overflow = ''; }
      return;
    }

    var q = t.closest('[data-kzo-qty]');
    if (q) {
      var inp = q.parentNode.querySelector('input');
      var v = parseInt(inp.value, 10) || 0;
      var min = parseInt(inp.min, 10) || 0;
      v = q.getAttribute('data-kzo-qty') === 'up' ? v + 1 : Math.max(min, v - 1);
      inp.value = v;
      if (inp.hasAttribute('data-kzo-auto')) inp.form.submit();
      return;
    }

    var m = t.closest('[data-kzo-more]');
    if (m) {
      e.preventDefault();
      if (m.classList.contains('is-loading')) return;
      m.classList.add('is-loading');
      m.textContent = 'Loading';
      var url = m.getAttribute('href');
      fetch(url).then(function (r) { return r.text(); }).then(function (h) {
        var doc = new DOMParser().parseFromString(h, 'text/html');
        var g = d.querySelector('[data-kzo-grid]');
        doc.querySelectorAll('[data-kzo-grid] > *').forEach(function (n) { g.appendChild(d.importNode(n, true)); });
        var nw = doc.querySelector('[data-kzo-morewrap]');
        var w = d.querySelector('[data-kzo-morewrap]');
        if (w) w.innerHTML = nw ? nw.innerHTML : '';
      }).catch(function () { location.href = url; });
      return;
    }

    var cp = t.closest('[data-kzo-coupon]');
    if (cp) {
      var ci = cp.parentNode.querySelector('input');
      var code = ci.value.trim();
      if (code) location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
      return;
    }

    d.querySelectorAll('details.kzo-filter[open]').forEach(function (x) {
      if (!x.contains(t)) x.removeAttribute('open');
    });
  });

  d.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var f = t.closest('form[data-kzo-filters]');
    if (f) {
      f.querySelectorAll('input[type=number]').forEach(function (n) { if (n.value === '') n.disabled = true; });
      f.submit();
      return;
    }
    if (t.hasAttribute('data-kzo-auto')) t.form.submit();
  });

  // product variants
  d.querySelectorAll('[data-kzo-product]').forEach(function (root) {
    var j = root.querySelector('[data-kzo-json]');
    if (!j) return;
    var data = JSON.parse(j.textContent);
    var groups = root.querySelectorAll('.kzo-opt');
    if (!groups.length) return;

    function chosen() {
      var o = [];
      groups.forEach(function (g) { var c = g.querySelector('input:checked'); o.push(c ? c.value : null); });
      return o;
    }
    function find(o) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var k = 0; k < o.length; k++) { if (v.options[k] !== o[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function mark() {
      var o = chosen();
      groups.forEach(function (g, gi) {
        g.querySelectorAll('input').forEach(function (inp) {
          var t = o.slice(); t[gi] = inp.value;
          var v = find(t);
          inp.classList.toggle('is-out', !v || !v.available);
        });
      });
    }
    function update() {
      var v = find(chosen());
      var btn = root.querySelector('[data-kzo-add]');
      var id = root.querySelector('input[name="id"]');
      mark();
      groups.forEach(function (g) {
        var c = g.querySelector('input:checked'), s = g.querySelector('[data-kzo-optval]');
        if (c && s) s.textContent = c.value;
      });
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      id.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Add to bag' : 'Sold out';
      var p = root.querySelector('[data-kzo-price]'), cm = root.querySelector('[data-kzo-compare]'),
          off = root.querySelector('[data-kzo-off]'), sku = root.querySelector('[data-kzo-sku]');
      if (p) p.innerHTML = fmt(v.price);
      var on = v.compare_at_price && v.compare_at_price > v.price;
      if (cm) { cm.style.display = on ? '' : 'none'; if (on) cm.innerHTML = fmt(v.compare_at_price); }
      if (off) { off.style.display = on ? '' : 'none'; if (on) off.textContent = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% off'; }
      if (sku) sku.textContent = v.sku ? 'SKU: ' + v.sku : '';
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (err) {}
    }
    root.addEventListener('change', function (e) { if (e.target.closest('.kzo-opt')) update(); });
    mark();
  });

  // product recommendations
  d.querySelectorAll('[data-kzo-recs]').forEach(function (el) {
    fetch(el.getAttribute('data-kzo-recs')).then(function (r) { return r.text(); }).then(function (h) {
      var doc = new DOMParser().parseFromString(h, 'text/html');
      var n = doc.querySelector('[data-kzo-recs]');
      if (n && n.innerHTML.trim()) el.innerHTML = n.innerHTML;
    }).catch(function () {});
  });
})();
